import { PARTICIPANT_RELATION } from "../components/modules/loanApplication/SummaryAndAdjust/config";
import { ONBOARDING_PARTICIPANT_ROLES } from "../components/shared/config";

export const fakeFormsDataKYCAutomatic = {
  KYC_AUTOMATIC: {},
};

export const fakeFormsDataKYCManual = {
  DOC_ID_FORM: {
    documentExpeditor: "ESP",
    documentNumber: "41097529W",
    documentType: "DNI_ES",
    expiration: new Date(
      "Thu Mar 10 2032 14:49:01 GMT+0200 (hora de verano de Europa central)"
    ),
  },
  PERSONAL_INFO_FORM: {
    firstName: "Víctor",
    lastName: "Rodríguez Sancho",
    gender: "M",
  },
  BIRTH_INFO_FORM: {
    birthCity: "Barcelona",
    birthProvince: "Barcelona",
    birthdate: new Date(
      "Thu Apr 30 1985 14:49:01 GMT+0200 (hora de verano de Europa central)"
    ),
    documentExpeditor: "ESP",
  },
  DOC_ID_PICTURE: {
    dniEsFront: {
      result:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAArwAAALCAQMAAAAGXJKxAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAZQTFRFR3BMAAAAnyqEUQAAAAF0Uk5TAEDm2GYAAABdSURBVHja7cxBDQAACAQg7V/WBlrB720QgCoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABi9L6MODg+hVDow8DmEnoAAAAASUVORK5CYII=",
      name: "foto-dni-frente.png",
      size: 218,
      type: "image/png",
    },
    dniEsBack: {
      result:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAArwAAALCAQMAAAAGXJKxAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAZQTFRFR3BMAAAAnyqEUQAAAAF0Uk5TAEDm2GYAAABdSURBVHja7cxBDQAACAQg7V/WBlrB720QgCoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABi9L6MODg+hVDow8DmEnoAAAAASUVORK5CYII=",
      file: {},
      name: "foto-dni-reverso.png",
      size: 218,
      type: "image/png",
    },
  },
  BIRTH_INFO_NIE_EU: {
    gender: "M",
    nationality: "ESP",
  },
  DOC_ID_PICTURE_NIE_EU: {
    passportFront: {
      result:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAArwAAALCAQMAAAAGXJKxAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAZQTFRFR3BMAAAAnyqEUQAAAAF0Uk5TAEDm2GYAAABdSURBVHja7cxBDQAACAQg7V/WBlrB720QgCoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABi9L6MODg+hVDow8DmEnoAAAAASUVORK5CYII=",
      file: {},
      name: "foto-pasaporte-bio.png",
      size: 218,
      type: "image/png",
    },
  },
  ADDRESS_DATA_FORM: {
    address: {
      address: "Carrer de Balmes 23, 08007 Barcelona, España",
      postalCode: "08007",
      country: "ESP",
      streetNumber: "23",
      streetName: "Carrer de Balmes",
      city: "Barcelona",
      province: "Barcelona",
      countryLongName: "España",
      regionShortName: "CT",
      region: "Catalunya",
      provinceShortName: "B",
      latitude: 41.3878206,
      longitude: 2.1642692,
      floorNumber: "4",
      doorNumber: "1",
      building: "A",
    },
  },
  ADDRESS_COMPLEMENT_DATA_FORM: {
    complementAddress: {
      floorNumber: "4",
      doorNumber: "1",
      building: "A",
    },
  },
  RESIDENCE_DATA_FORM: {
    ownershipType: "ownership",
    entranceDate: new Date(
      "Thu Sep 20 2015 14:49:01 GMT+0200 (hora de verano de Europa central)"
    ),
    homeExpensesAmount: undefined,
  },
  PROPERTY_TYPE_DATA_FORM: {
    ownershipType: "ownership",
    homeExpensesAmount: "420,00 €",
    mortgage: true,
    propertyType: "private_contract",
  },
  UTILITIES_SUPPLY_CUPS_NUMBER: {
    cupsCode: "ES0987543210987654ZF",
  },
  FAMILIAR_DATA_FORM: {
    childSupportNumber: 1,
    maritalRegime: "matrimonial_assets",
    maritalStatus: "married",
  },
};

export const fakeFormsDataProfessionalDetails = {
  PROFESSIONAL_DATA_EMPLOYMENT_FORM: {
    employmentStatus: "indefinite_employed",
    professionalPosition: "manager",
    companySeniority: new Date(
      "Thu Apr 30 2018 14:49:01 GMT+0200 (hora de verano de Europa central)"
    ),
    contractDateEnd: new Date(
      "Mon Mar 13 2023 14:49:01 GMT+0200 (hora de verano de Europa central)"
    ),
  },
  PROFESSIONAL_DATA_ADDITIONAL_SELF_EMPLOYED_FORM: {
    selfEmploymentNetIncomeValue: "4.450,00 €",
    selfEmploymentNetIncomeDate: new Date(
      "Thu Jan 30 2025 14:49:01 GMT+0200 (hora de verano de Europa central)"
    ),
  },
  PROFESSIONAL_DATA_COMPANY_FORM: {
    companyActivity: "commerce",
    companyName: "Ikea",
    companyCity: "Barcelona",
    corporateIdNumber: "A07730559",
  },
};

export const fakeFormsDataIncome = {
  EDIT_INCOME_FORM: {
    netIncomeType: "salary",
    monthlyIncome: "2.450,00 €",
    numberOfPaymentsPerYear: 14,
  },
  SET_BANK_ACCOUNT: {
    bankAccountIBAN: "ES1000492352082414205416", //IBAN Santander
    // bankAccountIBAN: "ES6621000418401234567891", //IBAN CaixaBank
  },
};

export const fakeFormsAddParticipantToLoan = {
  PARTICIPANT_PERSONAL_DATA: {
    participantRole: ONBOARDING_PARTICIPANT_ROLES.CO_BORROWER,
    participantRelation: PARTICIPANT_RELATION.SIBLING,
    participantFirstName: "Marta",
    participantLastName: "Oviedo Planas",
    participantDocumentNumber: "40794193J",
  },
  PARTICIPANT_CONTACT_DATA: {
    participantEmail: "marta.planas@nemuru.com",
    participantPhoneNumber: "658741256",
  },
};
